interface DashboardCardContentValueProps {
  value: string;
  unit?: string;
  children?: React.ReactNode;
}

export function DashboardCardContentValue({ value, unit, children }: DashboardCardContentValueProps) {
  return (
    <div className="flex gap-2" data-testid="card-content-value">
      <span className="text-white text-4xl font-bold">{value}</span>
      <span className="flex items-end text-[0.86625rem] text-gray-300">{unit}</span>
      {children}
    </div>
  );
}
